import { Box, Button, Divider, FormControl, FormLabel, HStack, Image, Input, Select, Stack, Text } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { getUser, updateUser } from '../../store/actions';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import { ToastContainer } from 'react-toastify';
import { registerFormTypes } from '../../types';
import { updateUserFormValidation } from '../../utils';
import { useFormik } from 'formik';

export const ProfileView = () => {

    // const [image, setImage] = useState<any>();

    const { user, is_updating_user } = useAppSelector(state => state.userReducer);
    const { company } = useAppSelector(state => state.companyReducer);
    const { company_id } = company ?? {};

    const dispatch: AppDispatch = useAppDispatch();

    const updateForm = useFormik({
        initialValues: {
            phone: '',
        },
        validationSchema: updateUserFormValidation,
        onSubmit: (values: registerFormTypes) => {
            const newValues = { ...user, ...values, company_id };
            dispatch(updateUser(user?._id, newValues)).then(() => dispatch(getUser()));
        }
    });

    // const changeHandler = (event: any) => {
    //     setImage(event.target.files[0]);
    // };

    // const handleUpload = async () => {
    //     const formData = new FormData();

    //     formData.append('upload_image', image);

    //     dispatch(uploadImage(formData));
    // };

    useEffect(() => {
        dispatch(getUser());
        return () => {
            updateForm.setFieldValue('phone', user?.phone);
        };
    }, [is_updating_user]);

    return (
        <Stack bg={'#FFFFFF'} p={6} borderRadius={6}>
            <Stack>
                <HStack justifyContent={'space-between'}>
                    <Text textTransform={'capitalize'} fontWeight={'semibold'} fontSize={'1.5rem'} >my profile</Text>
                </HStack>
                <Divider />
                <HStack py={6} justifyContent={'center'}>
                    <Image
                        boxShadow={'md'}
                        borderRadius={'lg'}
                        boxSize='150px'
                        alt={user?.img_url || 'Profile image'}
                        src={user?.img_url || 'data:image/png;base64,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'}
                    />{' '}
                    {/* <Stack pl={4}>
                        <input className="custom-file-input" name='upload_image' type='file' onChange={changeHandler} />
                        <Button colorScheme='yellow' size='sm' onClick={handleUpload}>
                            Change image
                        </Button>
                        <Button leftIcon={<FiTrash2 />} variant={'outline'} colorScheme='red' size='sm'>
                            Delete
                        </Button>
                    </Stack> */}
                </HStack>
            </Stack>
            <Stack w={['100%', '100%', 'xl']} alignSelf={'center'}>
                <form onSubmit={updateForm.handleSubmit}>
                    <HStack>
                        <Box minW={'50%'}>
                            <FormControl>
                                <FormLabel>First name</FormLabel>
                                <Input variant='filled' type='text' disabled value={user?.first_name} textTransform={'capitalize'} />
                            </FormControl>
                        </Box>
                        <Box minW={'50%'}>
                            <FormControl>
                                <FormLabel>Last name</FormLabel>
                                <Input variant='filled' type='text' disabled value={user?.last_name} textTransform={'capitalize'} />
                            </FormControl>
                        </Box>
                    </HStack>
                    <HStack py={3}>
                        <Box minW={'50%'}>
                            <FormControl>
                                <FormLabel>Email</FormLabel>
                                <Input variant='filled' type='email' disabled value={user?.email} />
                            </FormControl>
                        </Box>
                        <Box minW={'50%'}>
                            <FormControl>
                                <FormLabel>Phone number</FormLabel>
                                <Input name='phone' type='tel' value={updateForm.values.phone} onChange={updateForm.handleChange} />
                                {updateForm.errors.phone && <Text fontSize='sm' color='red.400'>{updateForm.errors.phone}</Text>}
                            </FormControl>
                        </Box>
                    </HStack>
                    <HStack>
                        <Box minW={'50%'}>
                            <FormControl>
                                <FormLabel>Role</FormLabel>
                                <Select variant='filled' value={user?.role} defaultValue={user?.role} textTransform={'capitalize'} placeholder={user?.role} disabled>
                                    <option>United Arab Emirates</option>
                                    <option>Nigeria</option>
                                </Select>
                            </FormControl>
                        </Box>
                        <Box minW={'50%'}>
                            <FormControl>
                                <FormLabel>Gender</FormLabel>
                                <Select variant='filled' placeholder={user?.gender} value={user?.gender} textTransform={'capitalize'} disabled>
                                    <option>United Arab Emirates</option>
                                    <option>Nigeria</option>
                                </Select>
                            </FormControl>
                        </Box>
                    </HStack>
                    <Stack pt={4}>
                        <Button
                            type='submit'
                            disabled={is_updating_user}
                            isLoading={is_updating_user}
                            loadingText={'Submitting...'}
                            colorScheme='yellow'
                            size='md'>
                            Update
                        </Button>
                    </Stack>
                </form>
            </Stack>
            <ToastContainer />
        </Stack>
    );
};